import Icon from '../components/Icon.vue'

Icon.register({"umbrella":{"width":576,"height":512,"paths":[{"d":"M557 267.6C505.6 222.4 449.4 223.9 398.4 298.4 393.1 306.2 383.5 305.5 378.7 298.4 376.2 294.7 346.5 237.6 288 237.6 242.2 237.6 217.5 268.9 197.3 298.4 192.5 305.5 182.9 306.2 177.6 298.4 126.7 224.1 70.9 222 19 267.6 8.8 275.9-1.9 266.5 0.3 258.1 32.1 134.6 158.5 64.6 288 64.6 416.8 64.6 544.5 134.6 575.7 258.1 577.9 266.5 567.3 275.9 557 267.6zM256 261V416C256 433.6 241.6 448 224 448S192 433.6 192 416C192 398.3 177.7 384 160 384S128 398.3 128 416C128 468.9 171.1 512 224 512S320 468.9 320 416V261.3C298.2 250.5 274.6 251.6 256 261zM320 50V32C320 14.3 305.7 0 288 0S256 14.3 256 32V50A372.1-372.1 0 0 0 320 50z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/umbrella.js
// module id = null
// module chunks = 